import './UnderlineTabbedInterface-490822a1.css';

var classes = {"UnderlineWrapper":"prc-components-UnderlineWrapper-oOh5J","UnderlineItemList":"prc-components-UnderlineItemList-b23Hf","UnderlineItem":"prc-components-UnderlineItem-lJsg-","LoadingCounter":"prc-components-LoadingCounter-Ps-0Q","loadingCounterKeyFrames":"prc-components-loadingCounterKeyFrames-wsxQl"};

export { classes as default };
